import Vue from 'vue';
import Vuex from 'vuex';
import * as getters from './getters';
import options from './modules/options';
import mutations from './mutations';

Vue.use(Vuex);

const state = {
  success: 0,
  error: null,
  loader: false,
};

export default new Vuex.Store({
  state,
  getters,
  mutations,
  modules: {
    options,
  },
});
